import { render } from "./Rank.vue?vue&type=template&id=f60b5fd6"
import script from "./Rank.vue?vue&type=script&lang=js"
export * from "./Rank.vue?vue&type=script&lang=js"

import "./Rank.vue?vue&type=style&index=0&id=f60b5fd6&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__